export default __webpack_public_path__ + "static/media/13.f8d82944.jpeg";